import merge from 'lodash/merge.js';

import BaseCourseTemplateForm from '@/store/modules/base/BaseCourseTemplateForm.js';

// TODO: CourseTemplateForm needs to be refactored to support both states

export default merge(
    BaseCourseTemplateForm({
        type: '',
        activityType: 'Activities',
        sectionType: 'Sections',
    }),
    {
        state: {
            loading: false,
        },

        mutations: {
            TOGGLE_LOADING(state) {
                return (state.loading = !state.loading);
            },
        },
    }
);
